import { render, staticRenderFns } from "./SalaryReceiptActions.vue?vue&type=template&id=7d8c23f3&scoped=true&"
import script from "./SalaryReceiptActions.vue?vue&type=script&lang=js&"
export * from "./SalaryReceiptActions.vue?vue&type=script&lang=js&"
import style0 from "./SalaryReceiptActions.vue?vue&type=style&index=0&id=7d8c23f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8c23f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d8c23f3')) {
      api.createRecord('7d8c23f3', component.options)
    } else {
      api.reload('7d8c23f3', component.options)
    }
    module.hot.accept("./SalaryReceiptActions.vue?vue&type=template&id=7d8c23f3&scoped=true&", function () {
      api.rerender('7d8c23f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Invoices/History/SalaryReceiptActions.vue"
export default component.exports